import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { generateSkeletonKey } from '../../../../helpers/commonHelper';
import ActivityFeedItemSkeleton from '../ActivityFeedItemLoader/ActivityFeedItemLoader';

const ActivityFeedLoader = ({ itemCount = 6, fromRecommendationsPage = false }) => (
  <div className={`bg-white ${fromRecommendationsPage ? 'rounded-none' : 'rounded-xl shadow-card'}`}>
    <div className={`${fromRecommendationsPage ? '' : 'p-3 sm:p-4'}`}>
      <Skeleton width="40%" height={16} className="mb-[16px]" />
      <div className="space-y-3">
        {[...Array(itemCount)].map((_, idx) => (
          <ActivityFeedItemSkeleton key={generateSkeletonKey('activity', idx)} />
        ))}
      </div>
    </div>
  </div>
);

export default ActivityFeedLoader;
